<script>
import Splash from "@/components/Splash/Splash.vue";
import Sidebar from "@/components/Sidebar/Sidebar.vue";
import DefineProductivityRepresentations
  from "@/components/Financial_management_and_productivity/DefineProductivityRepresentations";

export default {
  components: {Sidebar, Splash, DefineProductivityRepresentations}
}
</script>

<template>
  <splash/>
  <div class="container mt-4" dir="rtl">
    <sidebar/>
    <div class="card-panel-main col-lg-9 mb-5 p-4" style="transform: translateX(-19vw)">

      <div class="card bg-white">
        <div class="d-flex m-3 justify-content-between border-bottom border-2">
          <p class="fw-bold">
            تعریف نماگرهای بهره‌وری
          </p>
        </div>

        <DefineProductivityRepresentations/>
      </div>
    </div>
  </div>
</template>
